import React from 'react';
import { useQuery } from '@apollo/client';
import PageContainer from 'components/@layout/PageContainer';
import GET_STUDENT from 'graph/student/get-student-query';
import PrintCertificate from 'components/PrintScreenModule/Certificates/components/PrintCertificate';
import { usePageContentLoading } from 'providers/PageContentLoadingProvider';

interface StudentCertificatesContainerProps {
  studentId: number;
  certificateType: string;
}

const StudentCertificatesContainer: React.FC<StudentCertificatesContainerProps> = ({
  studentId,
  certificateType
}) => {
  const [, { setLoading }] = usePageContentLoading();
  const { data, loading, error } = useQuery(GET_STUDENT, {
    variables: { where: { id: studentId } }
  });

  const handleOnLoad = (): void => {
    setLoading(false);
  };

  return (
    <PageContainer loading={loading} error={error}>
      <div>
        {data?.student && (
          <PrintCertificate
            key={`print-login-card-${data.student.id}`}
            certificateType={certificateType}
            firstName={data.student.firstName}
            lastName={data.student.lastName}
            onLoad={handleOnLoad}
          />
        )}
      </div>
    </PageContainer>
  );
};

export default StudentCertificatesContainer;
